<template>
  <div class="bottom-navbar sticky">
    <div class="nav-item" @click="handleNavClick('home')">
      <div class="nav-icon home-icon"></div>
      <div class="nav-text">{{ langData.home }}</div>
    </div>
    <div class="creation-btn" @click="handleCreateClick" v-if="activeNavTab === 'ugc'"></div>
    <div class="nav-item" @click="handleNavClick('ugc')" v-else>
      <div class="nav-icon fabu-icon"></div>
      <div class="nav-text">{{ langData.publish }}</div>
    </div>
    <div class="center-btn" v-if="activeNavTab === 'center'"></div>
    <div class="nav-item" @click="handleNavClick('center')" v-else>
      <div class="nav-icon center-icon"></div>
      <div class="nav-text">{{ langData.creativeCenter }}</div>
    </div>
  </div>
</template>

<script setup>
import LanguageHook from '@/hooks/language';

const props = defineProps({
  activeNavTab: {
    type: String,
    default: 'ugc'
  }
})

// 语言相关
const { langData } = LanguageHook();

// Emits
const emit = defineEmits(['switchNavTab', 'showCreatePopup']);

const tabMap = {
  // home: "首页",
  ugc: "我要发布",
  center: "作品管理",
}

// 方法
const handleNavClick = (tab) => {
  if (tabMap[tab]) {
    window.activityDataLayer.push({
      eventName: "click_button",
      eventType: tabMap[tab],
      eventReason: "UGC创作",
      aid: window.activity_name,
      gameId: window.game_id,
    });
  }
  emit('switchNavTab', tab);
};

const handleCreateClick = () => {
  emit('showCreatePopup');
};
</script>

